import React from "react";
import { Row, Col, Input, Button } from "reactstrap";

const CommonFilters = ({ config = [], filters, setFilters, onSearch, onReset, onAdd, actions = {}, }) => {
  const handleChange = (name, value) => {
  setFilters((prev) => ({
    ...prev,
    [name]: value,
    page: 1,
  }));
};

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSearch) {
      onSearch(filters);
    }
  };

  return (
    <div className="mb-3">
      <Row className="align-items-end">
        {config.map((item, index) => (
          <Col md={item.col || 3} key={index}>
            {item.type === "search" && (
              <Input
                placeholder={item.placeholder || "Search..."}
                value={filters[item.name] || ""}
                onChange={(e) =>
                  handleChange(item.name, e.target.value)
                }
                onKeyDown={handleKeyDown}
              />
            )}

            {item.type === "select" && (
              <Input
                type="select"
                value={filters[item.name] || ""}
                onChange={(e) =>
                  handleChange(item.name, e.target.value)
                }
              >
                <option value="">Select {item.label}</option>
                {item.options?.map((opt, i) => (
                  <option key={i} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Input>
            )}

            {item.type === "date" && (
              <Input
                type="date"
                value={filters[item.name] || ""}
                onChange={(e) =>
                  handleChange(item.name, e.target.value)
                }
              />
            )}
          </Col>
        ))}

        <Col md="auto" className="d-flex gap-2">
          {actions.showResetBtn && (
            <Button
              color="light"
              onClick={onReset}
              className="d-flex align-items-center gap-1"
            >
              <i className="mdi mdi-refresh" />
              Reset
            </Button>
          )}

          {actions.showAddBtn && (
            <Button
              color="success"
              onClick={onAdd}
              className="d-flex align-items-center gap-1"
            >
              <i className="mdi mdi-plus-circle" />
              {actions.addBtnText || "Add"}
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CommonFilters;